import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Table, Breadcrumb, Form, Spinner, Alert } from 'react-bootstrap';
import { RiMore2Fill, RiFileCopyLine, RiPencilLine, RiDeleteBinLine } from 'react-icons/ri';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ConfirmacionModal from '../../components/form-components/confirmacion-modal';
import { botsService } from '../../services/botsService';
import './bots.scss';

const Bots = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(3);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [botToDelete, setBotToDelete] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para cargar datos desde la API
  const loadBots = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const botsData = await botsService.getBots();
      const formattedData = botsService.formatDataForFrontend(botsData);
      setData(formattedData);
    } catch (err) {
      console.error('Error cargando bots:', err);
      setError(err.message || 'Error al cargar los bots');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Cargar datos al montar el componente
  useEffect(() => {
    loadBots();
  }, []);

  // Calcular el total de páginas
  const totalPages = Math.ceil(data.length / recordsPerPage);

  // Obtener los registros de la página actual
  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const handleToggleActivo = (index) => {
    const newData = [...data];
    newData[index].activo = !newData[index].activo;
    setData(newData);
  };

  const handleDeleteClick = (bot) => {
    setBotToDelete(bot);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (botToDelete) {
      const newData = data.filter(bot => bot !== botToDelete);
      setData(newData);
      setShowDeleteModal(false);
      setBotToDelete(null);
    }
  };

  return (
    <div className="bots-container">
      <div className="breadcrumb-header">
        <Breadcrumb>
          <Breadcrumb.Item active>Bots</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Row className="row-sm">
        <Col lg={12}>
          <Card className="custom-card">
            <Card.Body>
              <div className="bots-header">
                <h1 className="bots-title">Bots</h1>
                {/* <Button 
                  variant="primary" 
                  className="nuevo-bot-btn"
                  onClick={() => navigate('/bots/nuevo')}
                >
                  Nuevo bot
                </Button> */}
              </div>

              <hr className="separator" />

              <div className="bots-section">
                <h3 className="section-title">Registro de bots</h3>
                <p className="section-description">
                  En esta sección podrás configurar y visualizar todos los bots potenciados con I.A.
                </p>

                <div className="table-responsive">
                  <Table className="table-bots">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Género</th>
                        <th>Tipo de atención</th>
                        <th>Canal</th>
                        <th>Estado</th>
                        {/* <th>Acciones</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <Spinner animation="border" size="sm" />
                            <span className="ms-2">Cargando bots...</span>
                          </td>
                        </tr>
                      ) : error ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <Alert variant="danger" className="mb-0">
                              <Alert.Heading>Error al cargar datos</Alert.Heading>
                              <p className="mb-0">{error}</p>
                              <Button variant="outline-danger" size="sm" onClick={loadBots} className="mt-2">
                                Reintentar
                              </Button>
                            </Alert>
                          </td>
                        </tr>
                      ) : getCurrentPageData().length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            No se encontraron bots
                          </td>
                        </tr>
                      ) : (
                        getCurrentPageData().map((item, index) => (
                          <tr key={item.id || index}>
                            <td>
                              <span className="ms-2 text-capitalize">{item.nombre}</span>
                            </td>
                            <td>
                              <span className="ms-2 text-capitalize">{item.genero}</span>
                            </td>
                            <td>
                              <span className={`tipo-badge ${item.tipoAtencion}`}>
                                {item.tipoAtencion}
                              </span>
                            </td>
                            <td>
                              {item.canal.toLowerCase().includes('whatsapp') ? (
                                <i className="ri-whatsapp-line text-success canal-icon"></i>
                              ) : item.canal.toLowerCase().includes('messenger') ? (
                                <i className="ri-messenger-line text-primary canal-icon"></i>
                              ) : item.canal.toLowerCase().includes('instagram') ? (
                                <i className="ri-instagram-line text-danger canal-icon"></i>
                              ) : (
                                <i className="ri-phone-line text-secondary canal-icon"></i>
                              )}
                              <span className="text-capitalize">{item.canal}</span>
                            </td>
                            <td>
                              <span className={`estado-badge ${item.habilitado ? 'activo' : 'inactivo'}`}>
                                {item.habilitado ? 'Activo' : 'Inactivo'}
                              </span>
                            </td>
                            {/* <td>
                            <div className="d-flex align-items-center gap-3">
                              <Form.Check
                                type="switch"
                                id={`custom-switch-${index}`}
                                checked={item.activo}
                                onChange={() => handleToggleActivo(index)}
                                className="custom-switch"
                              />

                              <Dropdown align="end">
                                <Dropdown.Toggle
                                  as="span"
                                  variant="link"
                                  className="icono-dropdown p-0"
                                >
                                  <RiMore2Fill className="text-muted" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-end">
                                  <Dropdown.Item className="d-flex align-items-center">
                                    <RiFileCopyLine className="me-2" /> Duplicar
                                  </Dropdown.Item>
                                  <Dropdown.Item className="d-flex align-items-center">
                                    <RiPencilLine className="me-2" /> Editar
                                  </Dropdown.Item>
                                  <Dropdown.Item 
                                    className="d-flex align-items-center text-danger"
                                    onClick={() => handleDeleteClick(item)}
                                  >
                                    <RiDeleteBinLine className="me-2" /> Eliminar
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td> */}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="pagination-container">
                  <div className="records-per-page">
                    <span>Registros por página:</span>
                    <Form.Select
                      value={recordsPerPage}
                      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                      className="records-select"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </Form.Select>
                  </div>
                  <div className="pagination-controls">
                    <Button
                      variant="link"
                      className="page-nav"
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      &lt;
                    </Button>
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                      ) {
                        return (
                          <Button
                            key={pageNumber}
                            variant="link"
                            className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                            onClick={() => setCurrentPage(pageNumber)}
                          >
                            {pageNumber}
                          </Button>
                        );
                      } else if (
                        pageNumber === currentPage - 2 ||
                        pageNumber === currentPage + 2
                      ) {
                        return <span key={pageNumber} className="page-ellipsis">...</span>;
                      }
                      return null;
                    })}
                    <Button
                      variant="link"
                      className="page-nav"
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                    >
                      &gt;
                    </Button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmacionModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        title="¿Te gustaría eliminar permanentemente este bot?"
        message="Una vez eliminado, dejará de ser accesible."
        confirmButtonText="Eliminar"
        cancelButtonText="Cancelar"
      />
    </div>
  );
};

export default Bots;
